import Title from './Title';
const Powers = ({powers}) => {

      if(powers.length === 0 || powers.data) return 

      return (
            <div className="main_powers__content">
                  <div className="container">
                        <Title title={'Powers'} desc={'Prices'} />
                        <div className="main_table">
                              <table>
                                    <thead>
                                          <tr>
                                                <th>Power</th>
                                                <th>Name</th>
                                                <th>Category</th>
                                                <th>Price</th>
                                          </tr>
                                    </thead>
                                    <tbody>
                                          {
                                                powers.map((item) => (
                                                      <tr key={item.name}>
                                                            <td><img src={item.image} alt={item.name} /></td>
                                                            <td>{item.name}</td>
                                                            <td>{item.category}</td>
                                                            <td><strong>$ {item.price}</strong></td>
                                                      </tr>
                                                ))
                                          }
                                    </tbody>
                              </table>
                        </div>
                  </div>
            </div>
      )
}

export default Powers;